import { Link } from 'react-router-dom';

const LogoTitle = () => {
  return (
    <Link to="/" className="flex items-center gap-2">
      <img src="/squash.png" alt="Logo" className="h-10 w-10" />
      <span className="text-xl font-semibold text-gray-800">SquashHub</span>
    </Link>
  );
};

export default LogoTitle;
